module.exports = __webpack_public_path__ + "static/media/template1-carousel.3a0111f4.png";